import { motion } from 'framer-motion';
import { ArrowRight, Zap } from 'lucide-react';
import { Button } from '../ui/button';

export const CTA = () => {
  return (
    <section className="py-20 bg-white" data-testid="cta-section">
      <div className="container-main">
        {/* Warning Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-2xl sm:text-3xl lg:text-[36px] font-bold text-[#1E293B] leading-tight mb-6">
            Keep Doing It the Old Way… and You'll Keep<br />Getting the Same Results
          </h2>
          <p className="text-[#64748B] text-lg max-w-2xl mx-auto mb-4">
            If you keep using separate apps for chat and project management, you'll continue 
            losing time, focus, and momentum. Don't let scattered tools drain your team's productivity.
          </p>
          <p className="text-[#F97316] font-semibold">
            The longer you wait, the harder it gets to stay aligned.
          </p>
        </motion.div>

        {/* Main CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="text-center"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-[42px] font-bold text-[#1E293B] leading-tight mb-6">
            Bring Your Team Together —<br />Once and For All
          </h2>
          <p className="text-[#64748B] text-lg max-w-xl mx-auto mb-8">
            Your projects and conversations deserve to live in one place.
          </p>

          <Button
            size="lg"
            className="rounded-lg bg-[#2563EB] hover:bg-[#1D4ED8] text-white px-8 py-4 text-base font-semibold inline-flex items-center gap-2"
            data-testid="cta-final-button"
          >
            <Zap className="w-5 h-5" />
            Start Free at BoardChat.io
            <ArrowRight className="w-5 h-5" />
          </Button>

          <p className="text-[#64748B] text-sm mt-6">
            One platform. One price.{' '}
            <span className="text-[#1E293B] font-semibold">One place to get work done.</span>
          </p>
        </motion.div>
      </div>
    </section>
  );
};
